import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=0c8e54b5&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8e54b5')) {
      api.createRecord('0c8e54b5', component.options)
    } else {
      api.reload('0c8e54b5', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=0c8e54b5&", function () {
      api.rerender('0c8e54b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/app-manage/feedback.vue"
export default component.exports